import * as React from 'react'
import { SideDrawerForm } from '@sales-center/components'
import { ENTITY_TYPES } from '@sales-center/common'
import { DragServicesList } from './DragServiceProductsList/DragServicesList'
import { useData, useHandlers } from './hooks'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { getStyles } from './styles'
import { useTheme } from '@mui/material/styles'

export type Props = {
  onClose: () => void
  services: ILeadOppProduct[]
  entityType: ENTITY_TYPES
}

export function ReOrderServicesForm(props: Props) {
  const { onClose, services, entityType } = props

  const {
    disableCancel,
    disableSave,
    servicesReOrderTemp,
    setDisableCancel,
    setDisableSave,
    setServicesReOrderTemp,
  } = useData({ services })

  const { handleDragEnd, onSave } = useHandlers({
    entityType,
    onClose,
    servicesReOrderTemp,
    setDisableCancel,
    setDisableSave,
    setServicesReOrderTemp,
  })
  const styles = getStyles(useTheme())
  return (
    <SideDrawerForm
      disableCancel={disableCancel}
      disableSave={disableSave}
      onSave={onSave}
      onCancel={onClose}
      primaryBtnLabel="Apply"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        mr={1.5}
        ml={2}
        mt={2.7}
        mb={2.7}
      >
        <Box>
          <Typography variant="body1" sx={styles.formInfoLabel}>
            Re-Order Services to be Displayed
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" sx={styles.subFormInfoLabel}>
            (Drag to reorder)
          </Typography>
        </Box>
      </Box>

      <DragServicesList
        onDragEnd={handleDragEnd}
        services={servicesReOrderTemp}
      />
    </SideDrawerForm>
  )
}
